'use client';

import Link from 'next/link';
import { useLegalLinkRegistry, resolveLegalHref } from '@/lib/legal-links';

type Props = {
  context: 'signup' | 'organizer_registration' | 'organization_registration' | 'checkout' | 'event_registration';
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
};

export function LegalConsentCheckbox({ context, checked, onChange, className = '' }: Props) {
  const links = useLegalLinkRegistry();
  const termsHref = resolveLegalHref(links, 'terms-and-conditions', '/legal/terms-and-conditions');
  const privacyHref = resolveLegalHref(links, 'privacy-policy', '/legal/privacy-policy');

  return (
    <label className={`flex items-start gap-2 text-sm text-slate-600 ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1"
        required
      />
      <span>
        I agree to the{' '}
        <Link href={termsHref} className="text-primary hover:underline" target="_blank">Terms</Link>
        {' '}and{' '}
        <Link href={privacyHref} className="text-primary hover:underline" target="_blank">Privacy Policy</Link>
        {context === 'organizer_registration' && (
          <>
            ,{' '}
            <Link href={resolveLegalHref(links, 'organizer-agreement', '/legal/organizer-agreement')} className="text-primary hover:underline" target="_blank">
              Organizer Agreement
            </Link>
          </>
        )}
        .
      </span>
    </label>
  );
}
